import script from "./EurostarTicketsBox.vue?vue&type=script&setup=true&lang=ts"
export * from "./EurostarTicketsBox.vue?vue&type=script&setup=true&lang=ts"

import "./EurostarTicketsBox.vue?vue&type=style&index=0&id=3ff3fca2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ff3fca2"]])

export default __exports__